/**
 * @description Asset Type (also doubles as paramsVO pid, contentId, assetURL property names)
 */
export enum AssetEmbedType {

	/**
	 * @description Asset URL: i.e. Syncbak live streams
	 */
	ASSET_URL = 'assetURL',

	/**
	 * @description MPX PID: i.e. VOD, MPX DAI Live streams
	 */
	PID = 'pid',

	/**
	 * @description MPX Content ID: not used
	 */
	CID = 'contentId'

}